export function deriveTableSeatLayout(capacity) {
  const total = Math.max(2, Number(capacity) || 4);
  const shortSide = total >= 6 ? 1 : 0;
  return {
    longSide: Math.max(0, Math.floor((total - shortSide * 2) / 2)),
    shortSide,
  };
}

export function tableSeatLayout(table) {
  const fallback = deriveTableSeatLayout(table?.capacity);
  const longSide = Number(table?.seats_per_long_side);
  const shortSide = Number(table?.seats_per_short_side);
  return {
    longSide: Number.isInteger(longSide) && longSide >= 0 ? longSide : fallback.longSide,
    shortSide: Number.isInteger(shortSide) && shortSide >= 0 ? shortSide : fallback.shortSide,
  };
}

export function tableSeatCapacity(table) {
  const layout = tableSeatLayout(table);
  return 2 * (layout.longSide + layout.shortSide);
}

export function combinationSeatCapacity(tables, tableIds) {
  const byId = new Map(tables.map((table) => [table.id, table]));
  const orderedTables = tableIds.map((id) => byId.get(id)).filter(Boolean);
  if (orderedTables.length < 2 || orderedTables.length !== tableIds.length) return 0;

  const longSeats = orderedTables.reduce(
    (total, table) => total + tableSeatLayout(table).longSide * 2,
    0,
  );
  const leftEnd = tableSeatLayout(orderedTables[0]).shortSide;
  const rightEnd = tableSeatLayout(orderedTables[orderedTables.length - 1]).shortSide;
  return longSeats + leftEnd + rightEnd;
}
